window.addEventListener('load', () => {
  const navBar = document.getElementById('nav-bar');
  const navPos = navBar.offsetTop;
  const navBarHeight = navBar.offsetHeight;
  const offset = document.body.classList.contains('has-visual') ? navPos + navBarHeight : 0;

  window.addEventListener('scroll', () => {
    const scrollPos = window.scrollY;
    if (scrollPos > navPos + offset) {
      navBar.classList.add('sticky');
      if (!document.body.classList.contains('has-visual')) {
        document.body.style.paddingTop = `${navBarHeight}px`;
      } else {
        setTimeout(() => {
          navBar.classList.add('animate-in');
        }, 10);
      }
    } else {
      navBar.classList.remove('sticky', 'animate-in');
      document.body.style.paddingTop = null;
    }
  }, { passive: true });
});
